import { Component } from '@angular/core';

@Component({
  selector: 'allas-como-saber-cuando-cambiarlos',
  imports: [],
  template: `<main class="flex flex-col gap-2">
    <!-- Desktop Version -->
    <section class="hidden xl:flex flex-col xl:flex-row my-6 xl:my-12">
      <div class="h-auto xl:h-[500px]">
        <img
          src="/images/services/cambio-limpiaparabrisas/cambio-limpiaparabrisas.webp"
          alt="escobillas-necesitan-cambio"
          class="h-full w-auto object-cover"
        />
      </div>
      <div
        class="p-6 xl:p-12 flex flex-col items-center justify-center flex-auto xl:h-[500px]"
      >
        <article class="flex flex-col gap-2 items-center justify-center">
          <span class="flex items-center justify-center">
            <img
              src="/allas-icons/cambio-limpiaparabrisas.svg"
              alt="cambiar limpiaparabrisas"
              class="h-12 xl:h-20 w-auto"
            />
          </span>
          <span class="text-2xl xl:text-4xl font-bold fs-condensed text-center">
            ¿Cómo saber cuando tus Escobillas necesitan cambio?
          </span>
        </article>
      </div>
    </section>

    <!-- Mobile Version -->
    <section class="xl:hidden flex flex-col my-6">
      <!-- Texto arriba en mobile -->
      <div class="p-6 flex flex-col items-center justify-center">
        <article class="flex flex-col gap-2 items-center justify-center">
          <span class="flex items-center justify-center">
            <img
              src="/allas-icons/cambio-limpiaparabrisas.svg"
              alt="cambiar limpiaparabrisas"
              class="h-12 w-auto"
            />
          </span>
          <span
            class="xl:text-base text-2xl font-bold fs-condensed text-center"
          >
            ¿Cómo saber cuando tus Escobillas necesitan cambio?
          </span>
        </article>
      </div>
      <!-- Imagen abajo en mobile -->
      <div class="h-auto">
        <img
          src="/images/services/cambio-limpiaparabrisas/cambio-limpiaparabrisas.webp"
          alt="escobillas-necesitan-cambio"
          class="h-full w-full object-cover"
        />
      </div>
    </section>
    <section class="grid grid-cols-1 xl:grid-cols-2">
      @for (razon of razonesCambio; track razon.title) {
      <article
        class="flex flex-col gap-2 items-center justify-center border border-appBlack/50 p-6 xl:p-12"
      >
        <span class="flex items-center justify-center">
          <img
            [src]="razon.icon"
            [alt]="razon.title"
            class="h-12 xl:h-20 w-auto"
          />
        </span>
        <h2
          class="text-base xl:text-3xl font-bold fs-condensed text-center mt-2"
        >
          {{ razon.title }}
        </h2>
        <p
          class="text-sm xl:text-base font-light text-center mt-2 opacity-90"
          [innerHTML]="razon.description"
        ></p>
      </article>
      }
    </section>
  </main>`,
})
export class ComoSaberCuandoCambiarlos {
  razonesCambio = [
    {
      icon: '/allas-icons/rayas-parabarisas.svg',
      title: 'Dejando rayas en el parabrisas',
      description: `Las escobillas del limpiaparabrisas dejan rayas cuando están dobladas, dañadas o desgastadas. También pueden resecarse por la exposición al sol, lo que reduce su eficacia. En todos estos casos, la goma no se ajusta bien al parabrisas y no limpia correctamente.`,
    },
    {
      icon: '/allas-icons/ruidos-parabrisas.svg',
      title: 'Ruidos de chirridos durante el funcionamiento',
      description: `
Los ruidos desagradables y agudos no deberían acompañar el funcionamiento de escobilla de limpiaparabrisas. Si escucha chirridos cada vez que enciende sus limpiaparabrisas, indica que necesita cambio.
      `,
    },
    {
      icon: '/allas-icons/vibraciones-parabrisas.svg',
      title: 'El golpeteo o brinco causado por temperaturas extremas',
      description: `
        <span>
          El calor intenso o el frío extremo pueden causar el cascabeleo o que el limpiaparabrisas pierda su movimiento fluido. El calor puede hacer que la goma se quede fija en una posición, mientras que el frío la endurece, reduciendo su eficacia. Este problema puede resolverse usando limpiaparabrisas de tipo haz premium, que ofrecen mejor rendimiento y mayor durabilidad en cualquier clima.
        </span>
      `,
    },
    {
      icon: '/allas-icons/envejecimiento-parabrisas.svg',
      title: 'Envejecimiento y desgaste avanzado',
      description: `
        <span class="text-center block">
          Las escobillas del limpiaparabrisas se desgastan con el uso constante bajo lluvia, nieve, suciedad e insectos. Por eso, es importante <b>reemplazarlas regularmente</b>, idealmente <b>cada seis meses</b>, o antes si se usan en condiciones extremas.
        </span>
      `,
    },
  ];
}
